module.exports = "<app-product-list [categoryId]=\"route.snapshot.params.categoryId\">></app-product-list>\r\n\r\n"